import { useState } from 'react';

import { useAppDispatch, useUserTimezone } from '@/shared/hooks';
import { downloadFileFromURL, getFileSrc } from '@/shared/lib';

import { reportsModel } from '@/entities/reports';

// TODO: [4|m] Think how to move reportID to the downloadPDF arguments to avoid arguments for the hook.
export const useDownloadReportPDF = (
  reportID: string,
): {
  downloadReportPDF: () => Promise<void>;
  downloading: boolean;
} => {
  const [downloading, setDownloading] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  const userTimezone = useUserTimezone();

  const downloadReportPDF = async () => {
    setDownloading(true);

    try {
      const result = await dispatch(
        reportsModel.thunks.printReport({
          ReportID: reportID,
          Input: { case: 'GP', value: {} },
          TimeZone: userTimezone,
        }),
      );

      const content =
        reportsModel.thunks.printReport.fulfilled.match(result) &&
        result.payload.Document?.Kind.case === 'Report'
          ? result.payload.Document.Kind.value.Content
          : undefined;

      if (content?.case === 'RenderedDocument' && content.value.Document) {
        downloadFileFromURL(getFileSrc(content.value.Document.ID));
      }
    } finally {
      setDownloading(false);
    }
  };

  return {
    downloadReportPDF,
    downloading,
  };
};
